import React from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
  useDisclosure,
  Button,
} from "@chakra-ui/react";
import styles from "./style.module.css";
import withdraw from "../../../assets/withdraw.png";
import withdrawIcon from "../../../assets/withdrawIcon.png";


const WithdrawModel = ({ el, type }) => {
  // const dispatch = useDispatch()
  const { isOpen, onOpen, onClose } = useDisclosure();

  return (
    <>
      <p onClick={onOpen} className={styles.buttonWithdraw}>
       Withdraw
      </p>

      <Modal isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalCloseButton />
          <ModalBody></ModalBody>
          <div className={styles.deleteModeldiv}>
            <img src={withdraw} alt="" />

            <p>
              Are your sure want to withdraw this
              <br />
              ad campaign?
            </p>
          </div>

          <ModalFooter>
            <div className={styles.modelFooter}>
              <Button
                variant="solid"
                color="black"
                mr={3}
                //  onClick={() => dispatch(updateCurrentSubscriptionData({ deleted: true, SubscriptionId: el._id })).then(() => {
                //   dispatch(fetchCurrentSubscriptionData(type)).then(() => {
                //     onClose()
                //     message.error("Subscription had been deleted")
                //   })

                // })}
              >
                Yes
              </Button>
              <Button variant="outline" color="black" onClick={onClose}>
                No
              </Button>
            </div>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
};

export default WithdrawModel;
